@if (rows !== undefined) {
    <ecs-gear-oil-overview-table
        [items]="rows"
        [columns]="columns"
        [hideMarkedBar]="true"
        (rowSelect)="onRowSelect($event)"
    >
    </ecs-gear-oil-overview-table>
    <div class="action-buttons">
        <sew-button class="secondary s as-button">
            <button (click)="closeDialog()">{{ 'BUTTON.CANCEL' | translate }}</button></sew-button
        >
        <sew-button class="primary s as-button" [attr.disabled]="selectedGearOils.length > 0 ? null : true"
            ><button (click)="selectGearOils()">{{ 'BUTTON.SELECT' | translate }}</button></sew-button
        >
    </div>
}
